import { render, staticRenderFns } from "./GPathSessionList.vue?vue&type=template&id=2f3d36a1"
import script from "./GPathSessionList.vue?vue&type=script&lang=js"
export * from "./GPathSessionList.vue?vue&type=script&lang=js"
import style0 from "./GPathSessionList.vue?vue&type=style&index=0&id=2f3d36a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports